'use client'

import { Field as ChakraField } from '@chakra-ui/react';
import React from 'react';

export type FieldProps = {
	label?:        React.ReactNode;
	helperText?:   React.ReactNode;
	errorText?:    React.ReactNode;
	optionalText?: React.ReactNode;
} & Omit<ChakraField.RootProps, 'label'>;

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
	(props, ref) => {
		const {
			label, children, helperText, errorText, optionalText, ...rest
		}
      = props;

		return (
			<ChakraField.Root ref={ref} {...rest}>
				{label && (
					<ChakraField.Label>
						{label}
						<ChakraField.RequiredIndicator fallback={optionalText} />
					</ChakraField.Label>
				)}
				{children}
				{helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
				{errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
			</ChakraField.Root>
		);
	},
);

Field.displayName = 'Field';